import React from "react";

export const LogoutIcon: React.FC<{ width?: number; height?: number; fill?: string; opacity?: number }> = ({
    width = 20,
    height = 20,
    fill = "white",
    opacity = 1,
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity }}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2818 10.9872C14.1062 11.1881 14.1062 11.5137 14.2818 11.7145C14.4574 11.9154 14.7422 11.9154 14.9178 11.7145L15.693 10.828C16.1028 10.3594 16.1028 9.59957 15.693 9.13094L14.9178 8.24438C14.7422 8.04354 14.4574 8.04354 14.2818 8.24438C14.1062 8.44522 14.1062 8.77085 14.2818 8.97169L14.7133 9.46518H11.0461C10.7977 9.46518 10.5964 9.69543 10.5964 9.97946C10.5964 10.2635 10.7977 10.4937 11.0461 10.4937H14.7133L14.2818 10.9872Z"
            fill={fill}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.85031 16H11.1974C12.7704 16 14.0455 14.5417 14.0455 12.7429C14.0455 12.4588 13.8442 12.2286 13.5958 12.2286C13.3475 12.2286 13.1461 12.4588 13.1461 12.7429C13.1461 13.9737 12.2737 14.9714 11.1974 14.9714H8.9274C8.40782 15.6045 7.66945 16 6.85031 16ZM8.9274 5.02857H11.1974C12.2737 5.02857 13.1461 6.02634 13.1461 7.25714C13.1461 7.54118 13.3475 7.77143 13.5958 7.77143C13.8442 7.77143 14.0455 7.54118 14.0455 7.25714C14.0455 5.45827 12.7704 4 11.1974 4H6.85031C7.66945 4 8.40782 4.39547 8.9274 5.02857Z"
            fill={fill}
        />
        <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.99965 7.25714C3.99965 5.45827 5.27479 4 6.84776 4C8.42072 4 9.69586 5.45827 9.69586 7.25714V12.7429C9.69586 14.5417 8.42072 16 6.84776 16C5.27479 16 3.99965 14.5417 3.99965 12.7429V7.25714Z"
            fill={fill}
        />
    </svg>
);

export const WalletIcon: React.FC<{ width?: number; height?: number; fill?: string; opacity?: number }> = ({
    width = 20,
    height = 20,
    fill = "white",
    opacity = 1,
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity }}
    >
        <path
            d="M17 13H16.75V5.75C16.75 4.23 15.52 3 14 3H6C4.48 3 3.25 4.23 3.25 5.75V13H3C2.59 13 2.25 13.34 2.25 13.75C2.25 14.16 2.59 14.5 3 14.5H6.84003C7.18003 15.93 8.47 17 10 17C11.53 17 12.82 15.93 13.16 14.5H17C17.41 14.5 17.75 14.16 17.75 13.75C17.75 13.34 17.41 13 17 13ZM14.79 9.88C14.73 9.86 14.67 9.84 14.6 9.82C14.4 9.78 14.2 9.75 13.99 9.75H5.98999C5.77999 9.75 5.58 9.78 5.38 9.82C5.32 9.83 5.26 9.86 5.19 9.88C5.06 9.92 4.93 9.96 4.81 10.02C4.78 10.03 4.74998 10.04 4.72998 10.05V9C4.72998 8.31 5.28998 7.75 5.97998 7.75H13.98C14.67 7.75 15.23 8.31 15.23 9V10.05C15.2 10.04 15.18 10.03 15.15 10.02C15.05 9.96 14.92 9.92 14.79 9.88ZM6 4.5H14C14.69 4.5 15.25 5.06 15.25 5.75V6.56C14.87 6.37 14.45 6.25 14 6.25H6C5.55 6.25 5.13 6.37 4.75 6.56V5.75C4.75 5.06 5.31 4.5 6 4.5ZM12.5 13C12.09 13 11.75 13.34 11.75 13.75C11.75 14.71 10.96 15.5 10 15.5C9.04 15.5 8.25 14.71 8.25 13.75C8.25 13.34 7.91 13 7.5 13H4.75V12.5C4.75 11.81 5.31 11.25 6 11.25H14C14.69 11.25 15.25 11.81 15.25 12.5V13H12.5Z"
            fill={fill}
        />
    </svg>
);

export const ReferralsIcon: React.FC<{ width?: number; height?: number; fill?: string; opacity?: number }> = ({
    width = 20,
    height = 20,
    fill = "white",
    opacity = 1,
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity }}
    >
        <g opacity="0.4">
            <path
                d="M13.237 7.39451C13.1961 7.38867 13.1553 7.38867 13.1145 7.39451C12.2103 7.36534 11.4928 6.6245 11.4928 5.7145C11.4928 4.787 12.2453 4.02867 13.1786 4.02867C14.1061 4.02867 14.8645 4.78117 14.8645 5.7145C14.8586 6.6245 14.1411 7.36534 13.237 7.39451Z"
                fill={fill}
            />
            <path
                d="M15.1389 11.4372C14.4856 11.8747 13.5698 12.0381 12.7239 11.9272C12.9456 11.4489 13.0623 10.9181 13.0681 10.3581C13.0681 9.77474 12.9398 9.22057 12.6948 8.73641C13.5581 8.61974 14.4739 8.78307 15.1331 9.22057C16.0548 9.82723 16.0548 10.8247 15.1389 11.4372Z"
                fill={fill}
            />
            <path
                d="M6.76856 7.39451C6.80939 7.38867 6.85023 7.38867 6.89106 7.39451C7.79523 7.36534 8.51273 6.6245 8.51273 5.7145C8.51273 4.787 7.76023 4.02867 6.82689 4.02867C5.89939 4.02867 5.14106 4.78117 5.14106 5.7145C5.14689 6.6245 5.86439 7.36534 6.76856 7.39451Z"
                fill={fill}
            />
            <path
                d="M6.832 10.3582C6.832 10.924 6.9545 11.4607 7.17616 11.9449C6.35366 12.0324 5.49616 11.8574 4.86616 11.4432C3.9445 10.8307 3.9445 9.83318 4.86616 9.22068C5.49033 8.80068 6.37116 8.63152 7.1995 8.72485C6.96033 9.21485 6.832 9.76902 6.832 10.3582Z"
                fill={fill}
            />
        </g>
        <path
            d="M10.0821 12.1195C10.0355 12.1137 9.98296 12.1137 9.93046 12.1195C8.85712 12.0845 7.99962 11.2037 7.99962 10.1187C7.99962 9.01034 8.89212 8.11201 10.0063 8.11201C11.1146 8.11201 12.013 9.01034 12.013 10.1187C12.013 11.2037 11.1613 12.0845 10.0821 12.1195Z"
            fill={fill}
        />
        <path
            d="M8.18629 13.3274C7.30546 13.9165 7.30546 14.8849 8.18629 15.4682C9.18962 16.139 10.8346 16.139 11.838 15.4682C12.7188 14.879 12.7188 13.9107 11.838 13.3274C10.8405 12.6565 9.19545 12.6565 8.18629 13.3274Z"
            fill={fill}
        />
    </svg>
);

export const TransferIcon: React.FC<{ width?: number; height?: number; fill?: string; opacity?: number }> = ({
    width = 20,
    height = 20,
    fill = "white",
    opacity = 1,
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity }}
    >
        <path
            d="M15.69 11.4788C15.61 11.2988 15.47 11.1488 15.28 11.0688C15.19 11.0288 15.09 11.0088 14.99 11.0088H5C4.59 11.0088 4.25 11.3488 4.25 11.7588C4.25 12.1688 4.59 12.5088 5 12.5088H13.19L11.52 14.1788C11.23 14.4688 11.23 14.9488 11.52 15.2388C11.67 15.3888 11.86 15.4587 12.05 15.4587C12.24 15.4587 12.43 15.3888 12.58 15.2388L15.53 12.2888C15.6 12.2188 15.65 12.1388 15.69 12.0488C15.77 11.8588 15.77 11.6588 15.69 11.4788Z"
            fill={fill}
        />
        <path
            d="M4.31 8.51875C4.39 8.69875 4.53 8.84875 4.72 8.92875C4.81 8.96875 4.9 8.98875 5 8.98875H15C15.41 8.98875 15.75 8.64875 15.75 8.23875C15.75 7.82875 15.41 7.48875 15 7.48875H6.81L8.48 5.81875C8.77 5.52875 8.77 5.04875 8.48 4.75875C8.19 4.46875 7.71 4.46875 7.42 4.75875L4.47 7.70875C4.4 7.77875 4.35 7.85875 4.31 7.94875C4.23 8.13875 4.23 8.33875 4.31 8.51875Z"
            fill={fill}
        />
    </svg>
);
